/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ArrowRightLg: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="arrow-right-lg" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M680 1133.3333333333333L600.1 1053.4333333333334L916.3 736.6666666666667H226.6666666666667V623.3333333333334H916.3L600.1 306.5666666666666L680 226.6666666666668L1133.3333333333333 680L680 1133.3333333333333z" : "M544 906.6666666666666L480.08 842.7466666666667L733.0400000000001 589.3333333333333H181.3333333333334V498.6666666666666H733.0400000000001L480.0800000000001 245.2533333333334L544 181.3333333333333L906.6666666666669 544L544 906.6666666666666z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ArrowRightLg.displayName = `Blueprint5.Icon.ArrowRightLg`;
export default ArrowRightLg;
